import { Inject, Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableService } from "src/app/_metronic/shared/crud-table";
import { Brand } from "../models/brand.model";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { OrderingBrand } from "../../products/models/ordering-brand.model";

@Injectable({
  providedIn: "root",
})
export class BrandsService extends TableService<Brand> implements OnDestroy {
  BASE_URL = environment.apiUrl;
  GET_ALL_URL = "Brand/GetList";
  CREATE_URL = "Brand";
  UPDATE_URL = "Brand";
  DELETE_URL = "Brand";
  GET_ONE_URL = "Brand";

  constructor(
    @Inject(HttpClient) http,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(http, router, activatedRoute);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  getBrandsByCategories(categoryIds: number[]): Observable<OrderingBrand[]> {
    console.log(categoryIds);
    const catIdsStrfing = categoryIds.join(",");
    let params = new HttpParams();
    params = params.append("Categories", catIdsStrfing);
    return this.http.get<OrderingBrand[]>(
      `${this.BASE_URL}/${this.GET_ONE_URL}/GetByCategories`,
      { params }
    );
  }
}
